import { type IOption } from '@cian/ui-kit/types';

import { createSelector } from '@reduxjs/toolkit';

import { getFilters } from '../filters/getFilters';

import { locationsListSelector } from './locationsListSelector';

export const getLocationsForSelect = createSelector(
  locationsListSelector,
  getFilters,
  (locationsList, filters): IOption[] => {
    const locationVariantsCollection = new Set<number>(filters.locationVariants);

    return locationsList.reduce((acc, location) => {
      if (locationVariantsCollection.has(location.locationId)) {
        acc.push({ label: location.name, value: location.locationId });
      }

      return acc;
    }, Array.of<IOption>());
  },
);
